import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeByIds, removeOffersFromFolder } from '../../../thunk/favorites';
import { selectResults, selectSelectedProducts } from '../../../selectors';
import { plural } from '@cian/utils';
import { ModalConfirm } from '../../../components/ModalConfirm';
import { trackRemoveConfirm, trackRemoveFromFolder } from './tracking';
import { selectSelectedFolder } from '../../../selectors/folders';
import { Button } from '@cian/ui-kit';
import { useSelectedEntityIds } from '../../../hooks/favoriteEntities/useSelectedEntityIds';

interface IProps {
  entityId?: number;
  onClose(): void;
}

export function ModalConfirmRemoveFromFolderContainer({ entityId, onClose }: IProps) {
  const dispatch = useDispatch();
  const selectedProducts = useSelector(selectSelectedProducts);
  const selectedFolder = useSelector(selectSelectedFolder);
  const offerIds = useSelectedEntityIds(entityId);
  const { favoriteEntities } = useSelector(selectResults);
  const count = entityId ? 1 : selectedProducts.length;

  const handleRemoveFromFolder = () => {
    if (selectedFolder) {
      trackRemoveFromFolder(favoriteEntities);
      dispatch(removeOffersFromFolder(offerIds, selectedFolder.id));
    }

    onClose();
  };

  const handleRemoveFromFavorites = () => {
    trackRemoveConfirm(selectedProducts);
    dispatch(removeByIds(entityId));
    onClose();
  };

  const confirmText = `Удалить ${!entityId ? count + ' ' : ''}${plural(count, [
    'объявление',
    'объявления',
    'объявлений',
  ])}`;

  return (
    <ModalConfirm
      text={confirmText}
      footer={
        <React.Fragment>
          <Button size="XS" theme="fill_white_primary" onClick={handleRemoveFromFavorites}>
            Удалить из избранного
          </Button>
          <Button size="XS" onClick={handleRemoveFromFolder}>
            Удалить из подборки
          </Button>
        </React.Fragment>
      }
      onClose={onClose}
      isVisible={true}
    >
      <p>Удалить только из этой подборки или из всего избранного?</p>
    </ModalConfirm>
  );
}
